/* tslint:disable */
import * as React from 'react';
import { ThemeContext } from 'styled-components';
import camelCase from 'lodash/camelCase';

import { ISVGProps } from './common';

const SvgIconLoading: React.FC<ISVGProps> = ({ iconTitle, ...restProps }) => {
  const { themeTwo: { spinner: { withOutline, iconStrokeWidth, color, strokeLinecap}}} = React.useContext(ThemeContext);
  return (
    <svg fill="none" role="img" viewBox="0 0 38 38" {...restProps} xmlns="http://www.w3.org/2000/svg" aria-labelledby={camelCase(iconTitle) ? camelCase(iconTitle) : undefined}>
      <title id={camelCase(iconTitle)}>{iconTitle ? iconTitle : 'Loading'}</title>
      <g fill='none' strokeWidth={iconStrokeWidth ? iconStrokeWidth : 0.65} >
        <path id='loading-circle-outline' d="m37 19c0 9.9411-8.0589 18-18 18-9.94113 0-18-8.0589-18-18 0-9.94113 8.05887-18 18-18 9.9411 0 18 8.05887 18 18z" stroke="#d3dbda" strokeDasharray={withOutline ? undefined : 80} />
        <path id='animation-outline' d="m37 19c0-9.94113-8.0589-18-18-18" stroke={ withOutline ? "#214948" : `${color.circleOutline}`} strokeLinecap={strokeLinecap ? strokeLinecap : "square"}/>
      </g>
    </svg>
  );
}

export default SvgIconLoading;
